
export const ToLocalStringConvert =(NumberValue:number | string) =>{
    return NumberValue && (NumberValue).toLocaleString('en-US');
}
